<div [class.collapse]="!collapsed" id="andamentos{{ id }}" *ngIf="andamentos?.length && hasInformacaoAdicional()">
  <div class="mb-3">
    <fieldset class="border rounded-3 p-2 mt-0">
      <legend class="w-auto">{{ 'andamento.informacao_adicional' | translate }}</legend>
      <div class="mt-3 mb-2">
        <div class="row">
          <div
            class="col-xs-12 col-sm-12 col-md-12 course-tabs-content"
            id="course-tabs-content-{{ id }}"
            style="margin-top: -1%; margin-bottom: -2%">
            <article id="UNESP-{{ id }}" class="course-tab-item" style="display: block">
              <div class="panel panel-default">
                <table class="table table-striped table-hover">
                  <tbody>
                    <tr>
                      <td>
                        <div class="row" *ngIf="area">
                          <div class="col-xs-12 col-sm-8 col-md-9">
                            <span
                              class="course-tab-item-title"
                              style="line-height: 1.8em; font-size: 10pt; font-weight: bold">
                              {{ 'andamento.area' | translate }}
                              <span
                                >: <span style="font-weight: lighter">{{ area }}</span></span
                              >
                            </span>
                          </div>
                        </div>
                        <div class="row" *ngIf="departamento">
                          <div class="col-xs-12 col-sm-8 col-md-9">
                            <span
                              class="course-tab-item-title"
                              style="line-height: 1.8em; font-size: 10pt; font-weight: bold">
                              {{ 'andamento.departamento' | translate }}
                              <span
                                >: <span style="font-weight: lighter">{{ departamento }}</span></span
                              >
                            </span>
                          </div>
                        </div>
                        <div class="row" *ngIf="disciplinas">
                          <div class="col-xs-12 col-sm-8 col-md-9">
                            <span
                              class="course-tab-item-title"
                              style="line-height: 1.8em; font-size: 10pt; font-weight: bold">
                              {{ 'andamento.disciplinas' | translate }}
                              <span
                                >: <span style="font-weight: lighter">{{ disciplinas }}</span></span
                              >
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</div>
